import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

// Success toast with an "Undo" action that restores the cleared day snapshots.
export function toastWithUndo(message, programId, previous, onRestored) {
  toast.success(message, {
    duration: 10000,
    action: {
      label: "Undo",
      onClick: async () => {
        try {
          await api.post(`/programs/${programId}/days/restore`, { days: previous });
          toast.success("Restored");
          onRestored?.();
        } catch (err) {
          toast.error(formatApiError(err));
        }
      },
    },
  });
}
